import makeSlice from '@web/slices/purchaser/sliceMaker'

const slice = makeSlice()

export default slice.reducer
